export default "__VITE_ASSET__DfdTz$xk__"